import type { ICellRendererParams } from 'ag-grid-community';
import type { PromptOverviewTopBrand } from '../types';
import { BrandFavicon } from '../components/BrandFavicon';
import { getHelpDescription } from '../utils/help/help-content';

export function promptOverviewTopBrandsColumnConfig() {
  return [
    {
      field: 'canonicalName',
      title: 'برند',
      tooltip: getHelpDescription('tables.brand'),
      type: 'string',
      flex: 1,
      minWidth: 200,
      searchable: true,
      cellRenderer: (params: ICellRendererParams<PromptOverviewTopBrand>) => {
        const row = params.data;
        if (!row) return null;
        const isYou = row.relationship === 'you';
        return (
          <span className="d-flex align-items-center gap-2">
            <BrandFavicon
              host={row.domain}
              faviconUrl={row.faviconUrl}
              name={row.canonicalName}
              relationship={row.relationship}
            />
            <span className={`fw-medium ${isYou ? 'text-primary' : 'text-800'}`}>
              {row.canonicalName}
            </span>
          </span>
        );
      },
    },
    {
      field: 'aiMentions',
      title: 'تعداد منشن',
      tooltip: getHelpDescription('metrics.mention_count'),
      type: 'number',
      width: 130,
      searchable: true,
    },
    {
      field: 'shareOfVoice',
      title: 'سهم از دیده‌شدن',
      tooltip: getHelpDescription('metrics.share_of_voice'),
      type: 'number',
      width: 150,
      searchable: true,
      valueFormatter: (p: { value: number }) => `${p.value}%`,
    },
    {
      field: 'visibilityScore',
      title: 'دیده‌شدن در AI',
      tooltip: getHelpDescription('metrics.ai_visibility'),
      type: 'number',
      width: 140,
      searchable: true,
    },
    {
      field: 'avgPosition',
      title: 'میانگین رتبه',
      tooltip: getHelpDescription('tables.avg_position'),
      type: 'number',
      width: 130,
      searchable: true,
      valueFormatter: (p: { value: number | null }) => (p.value != null ? `${p.value}` : '—'),
    },
  ];
}
